import { Component, OnInit, Input, ChangeDetectionStrategy, Inject, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl, FormArray } from '@angular/forms';
// import { DecimalTrail } from './../../common/directives/TrailDecimal';
import { DecimalPipe } from '@angular/common';
import * as _ from 'lodash';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LGEDataService } from 'src/commons';
import { AngularMaterialService } from 'src/commons/utilities/angular.material.service';
import { Store } from '@ngrx/store';
import * as fromRoot from 'src/app/state/app.selectors';
import * as lgeApp from 'src/app/state/app.actions';

@Component({
    selector: 'process-external-request',
    templateUrl: '././process-external-request.component.html',
    styleUrls: ['././process-external-request.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProcessExternalRequestModal implements OnInit {
    @Input() title: string;
    @Input() message: string;
    @Input() confirmationData: any;
    @Input() info: any;

    externalRequestForm: FormGroup;
    confirm: any;
    isShowAccDist: boolean = false;
    type = '';
    isRequired: boolean = false;

    companyData: any = [];
    expTypeData: any = [];
    expOrgData: any = [];
    projectData: any = [];
    taskData: any = [];
    isADValid: boolean = false;
    ValidatingRow: number = 0;
    isValidatingRow = true;
    isFilled: boolean = false;
    isAwardedAmountEditable = true;
    numPipe = new DecimalPipe('en-Us');

    constructor(
        private fb: FormBuilder,
        private dialog: MatDialog,
        private ref: ChangeDetectorRef,
        @Inject(MAT_DIALOG_DATA) private data: any,
        private dialogRef: MatDialogRef<ProcessExternalRequestModal>,
        private _dataService: LGEDataService,
        private ams: AngularMaterialService,
        private store: Store<fromRoot.AppState>
    ) {
        this.title = data.title;
        this.message = data.message;
        this.confirmationData = data.confirmationData;
        this.info = data.info;
        this.type = this.info.type === 'PP' ? 'PP' : 'CI';
        this.isRequired = this.info.type === 'PP' && this.info.action === 'Approve';
        if (this.type === 'PP') {
            this.isShowAccDist = true;
        } else {
            this.isShowAccDist = this.confirmationData.statusId === 9 ? true : false;
            this.isADValid = true;
        }
        this.createForms();
    }

    // private twoDecMask = createNumberMask({
    //     prefix: '',
    //     suffix: '',
    //     includeThousandsSeparator: true,
    //     thousandsSeparatorSymbol: '',
    //     allowDecimal: true,
    //     decimalSymbol: '.',
    //     decimalLimit: 2,
    //     integerLimit: null,
    //     requireDecimal: false,
    //     allowNegative: false,
    //     allowLeadingZeroes: true
    // });

    public closeDialog(): Promise<any> {
        return new Promise<void>((resolve, reject) => {
            this.dialog.closeAll();
            resolve();
        });
    }

    ngOnInit() {
        this.externalRequestForm.setValue(this.confirmationData);
    }

    private createForms(): void {
        this.externalRequestForm = this.fb.group({
            formID: [null],
            requestNumber: [''],
            requestName: [''],
            comment: ['', [Validators.maxLength(50)]],
            amount: ['', [Validators.maxLength(20)]],
            statusId: [null],
            AccDistribution: this.fb.array([
                this.fb.group({
                    accDistributionId: [null],
                    formId: [null],
                    company: [''],
                    project: [''],
                    task: [''],
                    expType: [''],
                    expOrg: [''],
                    amount: ['']
                }),
                this.fb.group({
                    accDistributionId: [null],
                    formId: [null],
                    company: [''],
                    project: [''],
                    task: [''],
                    expType: [''],
                    expOrg: [''],
                    amount: ['']
                })
            ])
        });
        this.externalRequestForm.controls['AccDistribution'].valueChanges.subscribe(value => {
            let adArray = this.externalRequestForm.get('AccDistribution') as FormArray;
            this.isAwardedAmountEditable = !adArray.controls.some(ad => {
                return +ad.value.amount !== 0;
            })
            const validateObj = value[this.ValidatingRow];
            if (validateObj !== undefined) {
                if (validateObj.company !== ''
                    && validateObj.project !== ''
                    && validateObj.task !== '' && validateObj.expType !== ''
                    && validateObj.expOrg !== ''
                    && this.isValidatingRow) {
                    this.isValidatingRow = false;
                    this.Validate_Project_Task(validateObj);
                }
                this.callValidateAPI();
            }
        });

        if (this.type === 'PP' && this.info.action === 'Approve') {
            this.externalRequestForm.get(['AccDistribution', 0, 'company'])?.setValidators([Validators.required]);
            this.externalRequestForm.get(['AccDistribution', 0, 'project'])?.setValidators([Validators.required]);
            this.externalRequestForm.get(['AccDistribution', 0, 'task'])?.setValidators([Validators.required]);
            this.externalRequestForm.get(['AccDistribution', 0, 'expType'])?.setValidators([Validators.required]);
            this.externalRequestForm.get(['AccDistribution', 0, 'expOrg'])?.setValidators([Validators.required]);
            this.externalRequestForm.get(['AccDistribution', 0, 'amount'])?.setValidators([Validators.required]);
            this.externalRequestForm.get(['AccDistribution', 0])?.updateValueAndValidity();
        }

        // if(this.type === 'PP' && this.type.action === 'Reject') {
        //     this.externalRequestForm.get(['amount']).setValidators([Validators.required]);
        //     this.externalRequestForm.get(['amount']).updateValueAndValidity();
        // }

        this.getAccountingDistributionData();
        this.getProjectTaskData();
    }

    private getAccountingDistributionData() {
        const accDistParaArray = ['COMPANY', 'EXP_TYPE', 'EXP_ORG'];
        accDistParaArray.forEach(para =>
            this._dataService.AccDistInfo_GetActiveByName([para, this.type]).
                subscribe({
                    next: (data: any) => {
                        if (data) {
                            switch (para) {
                                case 'COMPANY':
                                    for (let i = 0; i < 2; i++) {
                                        this.companyData.push(data);
                                    }
                                    this.ref.markForCheck();
                                    break;
                                case 'EXP_TYPE':
                                    for (let i = 0; i < 2; i++) {
                                        this.expTypeData.push(data);
                                    }
                                    this.ref.markForCheck();
                                    break;
                                case 'EXP_ORG':
                                    for (let i = 0; i < 2; i++) {
                                        this.expOrgData.push(data);
                                    }
                                    this.ref.markForCheck();
                                    break;
                            }
                        }
                    },
                    error: error => {
                        this.ams.closeDialog();
                        this.ams.showAlert('Error!', `Please contact contributions@lge-ku.com with questions. \n Stack trace: ${error.message}`);
                        this.ref.markForCheck();
                    }
                })
        );

    }

    private getProjectTaskData() {
        this._dataService.ProjectTaskInfo_GetActiveByName(["PROJ_TASK_PLUS", 'CI']).subscribe({
            next:
                (data: any) => {
                    if (data) {
                        for (let i = 0; i < 2; i++) {
                            this.projectData.push(_.uniqBy(data, 'project'));
                            this.taskData.push(_.uniqBy(data, 'task'));
                        }
                        this.ref.markForCheck();
                    }
                },
            error: (error: Error) => {
                this.ams.showAlert('Error!', `Please contact contributions@lge-ku.com with questions. \n Stack trace: ${error.message}`);
                this.ref.markForCheck();
            }
        })
    }

    onAccDistSelect(value: any, index: number, selectedData: string): void {
        if (value) {
            this.ValidatingRow = index;
            this.isValidatingRow = true;
            switch (selectedData) {
                case 'company':
                    this.populateCompany(value, index);
                    this.externalRequestForm.get(['AccDistribution', index.toString(), 'project'])?.setValue('');
                    this.externalRequestForm.get(['AccDistribution', index.toString(), 'task'])?.setValue('');
                    break;

                case 'project':
                    this.externalRequestForm.get(['AccDistribution', index.toString(), 'task'])?.setValue('');
                    break;
                case 'task':
                    this.externalRequestForm.get(['AccDistribution', index.toString(), 'expType'])?.setValue('');
                    this.externalRequestForm.get(['AccDistribution', index.toString(), 'expOrg'])?.setValue('');
                    break;

                case 'expType':
                    this.externalRequestForm.get(['AccDistribution', index.toString(), 'expOrg'])?.setValue('');
                    break;
            }
        }
    }

    private populateCompany(value: any, index: number) {
        if (this.companyData[0] !== undefined) {
            if (index === 0) {
                const selectedComp = this.companyData[0].filter((x: { code: any; }) => x.code === value);
                let i = 1;
                for (i; i < 2; i++) {
                    this.companyData[i] = selectedComp;
                    this.externalRequestForm.get(['AccDistribution', i.toString(), 'company'])?.setValue('');
                }
            } else {
                if (this.externalRequestForm.controls['AccDistribution'].value[0].company === '') {
                    this.ams.showAlert('Error!', 'Please select company for first row!');
                    this.externalRequestForm.get(['AccDistribution', index.toString(), 'company'])?.setValue('');
                    return;
                }
            }
            this.ref.markForCheck();
        } else {
            this.populateCompany(value, index);
        }
    }

    private callValidateAPI() {

        for (let i = 0; i < 2; i++) { // 2 = this.accDistData.length
            const validateObj = this.externalRequestForm.controls['AccDistribution'].value[i];
            if (validateObj.company !== '' && validateObj.project !== '' && validateObj.task !== '' && validateObj.expType !== '' && validateObj.expOrg !== '' && validateObj.amount !== '') {
                this.isFilled = true;
            } else if (validateObj.company === '' && validateObj.project === '' && validateObj.task === '' && validateObj.expType === '' && validateObj.expOrg === '' && validateObj.amount === '') {
                this.isFilled = true;
            } else {
                this.isFilled = false;
                break;
            }
        }
    }

    private Validate_Project_Task(data: { project: any; task: any; expType: any; expOrg: any; company: any; }) {
        let validateObj: any = {
            project: data.project,
            task: data.task,
            expenditureType: data.expType,
            expenditureOrg: data.expOrg,
            company: data.company,
        }
        let jsonData = JSON.stringify(validateObj);
        this.ams.showLoader('Validating...');
        this._dataService.Validate_Project_Task(jsonData).
            subscribe({
                next: (data: string) => {
                    // this.ams.loader.close();
                    this.store.dispatch(new lgeApp.UpdateSplashScreenStatus(false, ''));
                    if (data) {
                        const validateResult = JSON.parse(data);
                        this.isADValid = validateResult.statusCode === 'VALID' ? true : false;
                        if (!this.isADValid) {
                            this.ams.showAlert(validateResult.statusCode, validateResult.statusMessage);
                        }
                        this.ref.markForCheck();
                    }
                },
                error: (error: Error) => {
                    this.isADValid = false;
                    this.ams.loader.close();
                    this.ams.showAlert('Unable to validate!', `Please contact contributions@lge-ku.com with questions. \n Stack trace: ${error.message}`);
                    this.ref.markForCheck();
                }
            })
    }

    calculateTotalAmount() {
        const projectDetails = this.externalRequestForm.controls['AccDistribution'].value;
        let newTotalAmount = 0;
        projectDetails.forEach((project: { amount: any; }) => {
            let amount = project.amount
            let newAmount;
            if (amount == undefined || amount == null || amount == '') {
                newAmount = 0;
            } else {
                newAmount = parseFloat(amount);
            }
            newTotalAmount += newAmount;
        });
        let temp = this.numPipe.transform(newTotalAmount.toFixed(2), '1.2-2')?.replace(/,/g, '');
        temp = temp?.split('.')[1] === "00" ? temp?.split('.')[0] : temp;
        this.isAwardedAmountEditable = temp === undefined ? false : +temp === 0;
        this.externalRequestForm.get('amount')?.setValue(temp);
    }

    onSave() {
        // console.log(this.externalRequestForm.value)
        if (this.isADValid === true) {
            this.dialogRef.close(this.externalRequestForm.value);
        } else {
            this.ams.showAlert('Alert', 'Your Accounting Distribution combination is Invalid!');
        }
    }

    onNoClick(): void {
        this.dialogRef.close('Skip');
    }

}